const U2F = [
    {serial: 'Decimal'},
    {serial: 'Example: \n 7827875'},
    {serial: '5234878'},
    {serial: '5295256'},
    {serial: '4694559'},
    {serial: '7799795'},
];

const YOTP = [
    {
        serial: 'Decimal',
        secret: '16 bytes Hex',
        publicIdentity: '1-16 Bytes Modhex',
        privateIdentity: '6 bytes Hex'
    },
    {
        serial: 'Example: \n 7826735',
        secret: '964f1a713b3546f8931e04b4d6647322',
        publicIdentity: '95c8fe2cf746',
        privateIdentity: 'ebb6f9762c28'
    },
    {
        serial: '5888878',
        secret: 'ae03d762f1af43b5a6d0769c0d47f8d6',
        publicIdentity: 'c223fda7a644',
        privateIdentity: 'bd5b6c27de98'
    },
    {
        serial: '4215256',
        secret: 'b37b365c0a8b452d9ad3adf1055d8e9b',
        publicIdentity: 'd2c9e7c81ff1',
        privateIdentity: 'b6320a610806'
    },
    {
        serial: '4655459',
        secret: '5b436a31f4534ded99e6940d3fc1127e',
        publicIdentity: 'dc5aa377be86',
        privateIdentity: '374d6741b42f'
    },
    {
        serial: '7799793',
        secret: '1ae76c959ece4216bd2af1b47754f2d0',
        publicIdentity: 'e1ac784d2341',
        privateIdentity: 'b80e4c693938'
    }
];

const USB_HOTP = [
    {serial: 'Decimal', secret: '20 bytes hexadecimal'},
    {serial: 'Example: \n 7823765', secret: '964f1a713b3546f8'},
    {serial: '5665878', secret: 'ae03d762f1af43b5'},
    {serial: '9255256', secret: 'b37b365c0a8b452d'},
    {serial: '4678959', secret: '5b436a31f4534ded'},
    {serial: '7799344', secret: '1ae76c959ece4216'},
];

const HOTP = [
    {serial: 'Hexadecimal', secret: 'Hexadecimal'},
    {serial: 'Example: \n 782d7b5', secret: '964f1a713b3546f8'},
    {serial: '5bfe878', secret: 'ae03d762f1af43b5'},
    {serial: 'b2b5256', secret: 'b37b365c0a8b452d'},
    {serial: '46bee59', secret: '5b436a31f4534ded'},
    {serial: '7799d9e', secret: '1ae76c959ece4216'},
];

export const samples = {
    YUBIKey_USB_KEY: {
        U2F,
        YOTP,
        HOTP: USB_HOTP
    },
    THIRD_PARTY: {
        TOTP: HOTP,
        HOTP: HOTP
    }
};



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/hard-token-integration-samples.js